import Component from '../component';

export default class KeyWords extends Component {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/key-words/key-words.js